/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_View_LabelInputs */



/**
* | output |
* | --- |
* | "Metadata View" |
*
* @param {Iconik_Metadata_View_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_view_label = /** @type {((inputs?: Iconik_Metadata_View_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_View_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Metadata View")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadata View")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metadata View")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Metadata View")
	if (locale === "es") return /** @type {LocalizedString} */ ("Metadata View")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Metadata View")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Metadata View")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Metadata View")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Metadata View")
	return /** @type {LocalizedString} */ ("Metadata View")
});